<div class="p-3 flex flex-column flex-auto">

    <div class="flex align-items-center justify-content-between mb-3 aagb-head">
        <h3 style="margin-bottom:0;">Bookings for {{BookingDate | date:'dd/MM/yyyy'}}</h3>
        <div>
            <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="loadgrid()"
                    pTooltip="Refresh Data"
                    style="margin-right: 10px;">
                <span class="pi pi-refresh"></span>
            </button>
            <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="goBack()"
                    pTooltip="Return to At a Glance">
                <span class="pi pi-angle-left" style="margin-right:8px;"></span>
                <span>Return to At a Glance</span>
            </button>
        </div>
    </div>

    <!-- The only date the buttons can act on is today, so it is said once here rather than on
         every row's dead button. -->
    <div *ngIf="!isBookingDateToday" class="aagb-notice">
        <span class="pi pi-info-circle"></span>
        <span>Customers can only be admitted on the day of their booking.</span>
    </div>

    <div style="width:100%">
        <div style="float:right; margin-bottom: 20px;">
            <span class="p-input-icon-left ml-auto" style="margin-right:20px;">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Name/Package/Sales ID"/>
            </span>
        </div>
    </div>

    <div *ngIf="!ListBookings || ListBookings.length === 0" style="width:100%">
        <p style="text-align:center; font-size:24px;">There are no bookings on this date.</p>
    </div>

    <div class="surface-card p-4 shadow-2 border-round">
        <p-table #resourceTable
            [value]="ListBookings"
            [paginator]="true"
            [rows]="25"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50,100]"
            [globalFilterFields]="['name', 'packageName', 'bookingIdHR']"
            responsiveLayout="scroll"
            sortField="startTime" [sortOrder]="1">
            <ng-template pTemplate="header">
                <tr>
                    <th width="1%">&nbsp;</th>
                    <th width="1%">&nbsp;</th>
                    <th pSortableColumn="bookingIdHR" width="9%">Sales ID
                        <p-sortIcon field="bookingIdHR"></p-sortIcon>
                    </th>
                    <th pSortableColumn="startTime" width="6%">Time
                        <p-sortIcon field="startTime"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name" width="13%">Name
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="admissions" width="16%">Admissions
                        <p-sortIcon field="admissions"></p-sortIcon>
                    </th>
                    <th pSortableColumn="packageName" width="14%">Package
                        <p-sortIcon field="packageName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="resourcestring" width="10%">Resource
                        <p-sortIcon field="resourcestring"></p-sortIcon>
                    </th>
                    <th pSortableColumn="guests" width="5%">Guests
                        <p-sortIcon field="guests"></p-sortIcon>
                    </th>
                    <th pSortableColumn="total" width="7%">Total
                        <p-sortIcon field="total"></p-sortIcon>
                    </th>
                    <th pSortableColumn="outstanding" width="7%">O/S
                        <p-sortIcon field="outstanding"></p-sortIcon>
                    </th>
                    <th width="9%">Allergy</th>
                    <th width="10%">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr
                    [ngStyle]="{'background-color': data.checkedin ? '#f0fdf4' : (data.allergy != '' && data.allergy != null) ? '#FFFFB2' : '#ffffff'}"
                    onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
                    onmouseout="this.style.backgroundColor=this.originalstyle;"
                    style="cursor:pointer;"
                    (click)="editBooking(data.bookingId)">
                    <td>
                        <span *ngIf="data.publicBooking" class="pi pi-user"></span>
                    </td>
                    <td>
                        <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                    </td>
                    <td>{{data.bookingIdHR}}</td>
                    <td>{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                    <td>{{data.name}} ({{maskMobile(data.phone)}})</td>
                    <td>{{data.admissions}}</td>
                    <td>{{data.packageName}}</td>
                    <td>{{data.resourcestring}}</td>
                    <td>{{data.guests}}</td>
                    <td>{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                    <td *ngIf="data.outstanding <= 0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                    <td *ngIf="data.outstanding > 0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                    <td>{{data.allergy}}</td>
                    <td (click)="$event.stopPropagation()">
                        <button *ngIf="!data.checkedin"
                                pButton type="button"
                                class="p-button-sm p-element p-ripple p-button-success p-button p-component"
                                style="width:100px;"
                                [disabled]="!isBookingDateToday"
                                (click)="admitall(data)">
                            <span class="pi pi-sign-in" style="margin-right:6px;"></span>
                            <span>Admit</span>
                        </button>
                        <button *ngIf="data.checkedin"
                                pButton type="button"
                                class="p-button-sm p-element p-ripple p-button-danger p-button p-component"
                                style="width:100px;"
                                [disabled]="!isBookingDateToday"
                                (click)="leaveall(data)">
                            <span class="pi pi-sign-out" style="margin-right:6px;"></span>
                            <span>Leave</span>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
